import { Component, Input } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ParkerRegistrationDTO, ParkerRegistrationOffense, ParkerRegistrationClient, PenaltyState } from 'src/app/base/models/models.swagger.generated';
import { ParkerRegistrationDetailsHelper } from '../parker-registration-details.helper';
import { AsyncImageComponent } from '../../../../base/shared/async-image/async-image.component';
import { TooltipModule } from '@syncfusion/ej2-angular-popups';
import { NgIf, NgClass, NgFor } from '@angular/common';

@Component({
    selector: 'app-parker-registration-detail-offense',
    templateUrl: './parker-registration-detail-offense.component.html',
    styleUrls: ['./parker-registration-detail-offense.component.scss'],
    standalone: true,
    imports: [NgIf, NgClass, TooltipModule, NgFor, AsyncImageComponent, TranslateModule]
})
export class ParkerRegistrationDetailOffenseComponent {
  @Input()
  public offense: ParkerRegistrationDTO;

  @Input()
  public displayIssuerName: boolean;

  public penaltyStateCancelled = PenaltyState.Cancelled;

  constructor(private translate: TranslateService,
    private parkerRegistrationClient: ParkerRegistrationClient) { }

  public getRegisteredByText(registration: ParkerRegistrationDTO): string {
    return ParkerRegistrationDetailsHelper.getRegisteredByText(registration, this.translate);
  }

  public getOffenseType(registration: ParkerRegistrationDTO): string {
    return !registration ? null : 'i18n.domain.parker-registration.ParkerRegistrationOffense.' + ParkerRegistrationOffense[registration.offense];
  }

  public getImageRequest(id: number, imageId: string): any {
    return this.parkerRegistrationClient.getRegistrationImage(id, imageId);
  }
}
